module.exports = __webpack_public_path__ + "static/white_tqj-122677148e6d938ea6656471e2978488.jpg";